// Used to be generated by 'yarn run build:variables'
// TODO [balazs] either try to eliminate the need to share constants across style
// TODO [balazs] and JS files or generate this file from frontend/src/assets/styles/components/_heatmap_variables.styl
const constants = {
  '$map-max-height-int': '400',
  '$map-max-height': '400px',
  '$map-overlay-text-color': '#777'
}
export default constants



// WEBPACK FOOTER //
// ./frontend/src/components/heatmap/heatmap_variables.js